module.exports = __webpack_public_path__ + "17.6ab5585e.png";